import { PropertyOnboardingStep } from '../configs/stages.enum';

export function getPropertyOnboardingStepRouteName(step: PropertyOnboardingStep) {
  return `property-onboarding-step-${step}`;
}
